<!--
  Redirects to Microsoft authentication and then to the home page
  once a user is logged in. This should only every log in Uniti
  employees.
-->
<template>
  <Container>
    <HeroText title="Authentication." subtitle="" />
  </Container>

  <div class="bg-white">
    <Container>
      <Text>
        <p class="mb-5">You will be redirected shortly. If not, please refresh the page.</p>
      </Text>
    </Container>
  </div>
</template>

<script lang="ts" setup>
import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { AuthenticationServiceInterface } from '@/services/authentication/authenticationServiceInterface';
import { onMounted } from 'vue';
import router from '@/router';
import store from '@/store';

const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

onMounted(async () => {
  const account = await authenticationService.doLogin();
  if (account) {
    store.commit('setAccount', account);
    router.push('/');
  }
});
</script>
